import * as React from "react";

export const DeleteIcon = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x={0}
        y={0}
        viewBox="0 1 24.64 22.73"
        width="1em" height="1em" fill="currentColor"
        xmlSpace="preserve"
    >
        <path
            d="M20.05 5.57a.34.34 0 0 0-.26-.1h-3.5l-.79-1.89c-.11-.28-.32-.52-.61-.71-.29-.2-.59-.3-.89-.3h-3.62c-.3 0-.6.1-.89.29-.29.2-.5.43-.61.71l-.8 1.9h-3.5a.34.34 0 0 0-.26.1.34.34 0 0 0-.1.26v.72c0 .11.03.19.1.26s.15.1.26.1h1.09v10.77c0 .63.18 1.16.53 1.6.35.44.78.66 1.28.66h9.42c.5 0 .92-.23 1.28-.68.35-.46.53-1 .53-1.62V6.92h1.09c.11 0 .19-.03.26-.1s.1-.15.1-.26v-.73c0-.11-.04-.19-.11-.26zm-9.84-1.43c.05-.07.12-.11.19-.12h3.59c.08.02.14.06.19.12l.54 1.32H9.65l.56-1.32zm7.05 13.5a1.344 1.344 0 0 1-.24.77c-.06.06-.1.1-.12.1H7.48c-.02 0-.06-.03-.12-.1-.06-.06-.11-.17-.16-.31-.05-.14-.08-.29-.08-.46V6.92h10.14v10.72zm0 0"
        />
        <path
            d="M8.93 16.33h.72c.11 0 .19-.03.26-.1s.1-.15.1-.26V9.45a.34.34 0 0 0-.1-.26.34.34 0 0 0-.26-.1h-.72a.34.34 0 0 0-.26.1.34.34 0 0 0-.1.26v6.52c0 .11.03.19.1.26s.15.1.26.1zM11.83 16.33h.72c.11 0 .19-.03.26-.1s.1-.15.1-.26V9.45a.34.34 0 0 0-.1-.26.34.34 0 0 0-.26-.1h-.72a.34.34 0 0 0-.26.1.34.34 0 0 0-.1.26v6.52c0 .11.03.19.1.26.06.07.15.1.26.1zM14.72 16.33h.72c.11 0 .19-.03.26-.1s.1-.15.1-.26V9.45a.34.34 0 0 0-.1-.26.34.34 0 0 0-.26-.1h-.72a.34.34 0 0 0-.26.1.34.34 0 0 0-.1.26v6.52c0 .11.03.19.1.26s.16.1.26.1zm0 0"
        />
    </svg>
)